const compatModules = {};
import * as Module1 from "./components/d-button-tooltip";
compatModules["./components/d-button-tooltip"] = Module1;
import * as Module2 from "./components/d-default-toast";
compatModules["./components/d-default-toast"] = Module2;
import * as Module3 from "./components/d-float-body";
compatModules["./components/d-float-body"] = Module3;
import * as Module4 from "./components/d-float-portal";
compatModules["./components/d-float-portal"] = Module4;
import * as Module5 from "./components/d-headless-menu";
compatModules["./components/d-headless-menu"] = Module5;
import * as Module6 from "./components/d-headless-tooltip";
compatModules["./components/d-headless-tooltip"] = Module6;
import * as Module7 from "./components/d-inline-float";
compatModules["./components/d-inline-float"] = Module7;
import * as Module8 from "./components/d-menu";
compatModules["./components/d-menu"] = Module8;
import * as Module9 from "./components/d-menus";
compatModules["./components/d-menus"] = Module9;
import * as Module10 from "./components/d-popover";
compatModules["./components/d-popover"] = Module10;
import * as Module11 from "./components/d-toast";
compatModules["./components/d-toast"] = Module11;
import * as Module12 from "./components/d-toasts";
compatModules["./components/d-toasts"] = Module12;
import * as Module13 from "./components/d-tooltip";
compatModules["./components/d-tooltip"] = Module13;
import * as Module14 from "./components/d-tooltips";
compatModules["./components/d-tooltips"] = Module14;
import * as Module15 from "./lib/constants";
compatModules["./lib/constants"] = Module15;
import * as Module16 from "./lib/d-menu-instance";
compatModules["./lib/d-menu-instance"] = Module16;
import * as Module17 from "./lib/d-toast-instance";
compatModules["./lib/d-toast-instance"] = Module17;
import * as Module18 from "./lib/d-tooltip-instance";
compatModules["./lib/d-tooltip-instance"] = Module18;
import * as Module19 from "./lib/float-kit-instance";
compatModules["./lib/float-kit-instance"] = Module19;
import * as Module20 from "./lib/get-scroll-parent";
compatModules["./lib/get-scroll-parent"] = Module20;
import * as Module21 from "./lib/update-position";
compatModules["./lib/update-position"] = Module21;
import * as Module22 from "./modifiers/apply-floating-ui";
compatModules["./modifiers/apply-floating-ui"] = Module22;
import * as Module23 from "./modifiers/auto-close-toast";
compatModules["./modifiers/auto-close-toast"] = Module23;
import * as Module24 from "./modifiers/close-on-escape";
compatModules["./modifiers/close-on-escape"] = Module24;
import * as Module25 from "./services/internal-tooltip";
compatModules["./services/internal-tooltip"] = Module25;
import * as Module26 from "./services/menu";
compatModules["./services/menu"] = Module26;
import * as Module27 from "./services/toasts";
compatModules["./services/toasts"] = Module27;
import * as Module28 from "./services/tooltip";
compatModules["./services/tooltip"] = Module28;
export default compatModules;